import { render } from "./Nav.vue?vue&type=template&id=ccfb5a6e&bindings={\"name\":\"setup\",\"version\":\"setup\",\"links\":\"setup\"}"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"
script.render = render

export default script